import React from 'react';

import "./ErrorPage.css";

const ErrorPage = () => {
    return (
        <div className='mt-[150px] mb-[150px]'>
            <h1 className="text-[120px] text-[rgb(83,_149,_241) text-center mb-0 font-bold]">404</h1>
            <h2 className="text-center text-2xl">Упс! Страница не найдена</h2>
        </div>
    );
};

export default ErrorPage;